<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
      <div class="p-3">ESIM Orders</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <!-- Loading indicator -->
        @if (loading) {
          <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }

        <!-- Error message -->
        @if (error && !loading) {
          <div class="alert alert-danger mt-3">
            {{ error }}
          </div>
        }

        <!-- AG Grid table -->
        @if (!loading && !error) {
          <div class="d-flex flex-column" style="height: 600px;">
            <ag-grid-angular
              style="width: 100%; flex: 1;"
              class="ag-theme-alpine"
              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions"
              (gridReady)="onGridReady($event)">
            </ag-grid-angular>
          </div>
        }

        <!-- No orders message -->
        @if (!loading && !error && orders.length === 0) {
          <div class="alert alert-info mt-3">
            No orders available at the moment.
          </div>
        }
      </div>
    </div>
  </div>
</div>